import React, { ReactElement } from 'react'

import Alert from '../../../../1stlog-ui/src/components/Alert'
import { Col, Row } from '../../../../1stlog-ui/src/components/Bootstrap'
import Button from '../../../../1stlog-ui/src/components/Button'
import ErrorBoundary from '../../../../1stlog-ui/src/components/ErrorBoundary'
import { FieldPrefix } from '../../../../1stlog-ui/src/components/Field'
import Icon from '../../../../1stlog-ui/src/components/Icon'
import CustomerAddress from '../Form/CustomerAddress'
import DeliveryAddress from '../Form/DeliveryAddress'
import ImporterAddress from '../Form/ImporterAddress'
import InvoiceAddress from '../Form/InvoiceAddress'
import NeutralSender from '../Form/NeutralSender'
import PickupAddress from '../Form/PickupAddress'
import SubmitButton from '../SubmitButton'
import { ClientNotifications } from './ClientNotifications'
import Colis from './Colis'
import Customs from './Customs'
// import DeliveryAddress from './DeliveryAddress'
import Misc from './Misc'
import Shipment from './Shipment'
import Transport from './Transport'

type TConfirmationProps = {
  onCancel: () => void
}

const Confirmation = (props: TConfirmationProps): ReactElement => {
  const { onCancel } = props

  return (
    <div>
      <ErrorBoundary>
        <Row>
          <Col>
            <Alert info className="mt-2">
              <Icon icon="fas fa-info-circle" />{' '}
              {i18n.t(
                `check_order_and_click_confirm`,
                `Bitte überprüfen Sie den erfassten Auftrag und klicken Sie dann auf "Bestätigen".`,
              )}
            </Alert>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FieldPrefix prefix="customer">
              <CustomerAddress readonly />
            </FieldPrefix>
            <FieldPrefix prefix="pickup">
              <PickupAddress readonly />
            </FieldPrefix>
            <FieldPrefix prefix="invoice">
              <InvoiceAddress readonly />
            </FieldPrefix>
            <FieldPrefix prefix="neutralSender">
              <NeutralSender readonly />
            </FieldPrefix>
            <FieldPrefix prefix="importer">
              <ImporterAddress readonly />
            </FieldPrefix>
          </Col>
          <Col md={6}>
            <FieldPrefix prefix="delivery">
              <DeliveryAddress readonly />
            </FieldPrefix>
          </Col>
        </Row>
        <Row>
          <Transport />
        </Row>
        <Row>
          <Col md={12}>
            <Shipment />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Colis />
          </Col>
        </Row>
        <Customs />
        <ClientNotifications />
        <Row>
          <Col md={12}>
            <Misc />
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end">
            <Button onClick={onCancel} className="mr-2">
              {i18n.t(`back_to_form`, `Zurück zum Formular`)}
            </Button>
            <SubmitButton isConfirmation />
          </Col>
        </Row>
      </ErrorBoundary>
    </div>
  )
}

export default Confirmation
